import type { Dict } from "../core.js";
import type { subscriptions as vi } from "../vi/subscriptions.js";

export const subscriptions: Dict<typeof vi> = {
  title: "Subscriptions",
  subtitle: "Latest snapshot by plan tier — a balance, not a running total over the period.",
  loadFailed: "Couldn't load subscription metrics.",
  aggregateNote: "sum of every app with a subscription table.",
  unmappedBanner: "customers are on plans not yet mapped to the shared axis.",
  planMappingLink: "Plan mapping",
  emptyTitle: "No subscription snapshots yet.",
  emptyHint: "Only sources with a notion of plans appear here — see the list below.",
  "col.tier": "Tier",
  "col.customers": "Customers",
  unmapped: "Unmapped",
};
